import { useEffect } from 'react'
import useSEO from '@/hooks/useSEO'
import usePrerenderReady from '@/hooks/usePrerenderReady'
import { creator } from '@/config/creator'
import FounderHero from '@/components/founder/FounderHero'
import PlatformCards from '@/components/founder/PlatformCards'
import CreatorFeeds from '@/components/founder/CreatorFeeds'
import FounderThoughts from '@/components/founder/FounderThoughts'
import PlatformSection from '@/components/founder/PlatformSection'
import FounderBio from '@/components/founder/FounderBio'
import FounderJourney from '@/components/founder/FounderJourney'
import FounderRecognition from '@/components/founder/FounderRecognition'
import MeetingSection from '@/components/founder/MeetingSection'

export default function FounderPage() {
  useSEO({
    title: 'Danilo Costa — Founder & CEO of Coderblock',
    description:
      "I'm Danilo Costa, Founder & CEO of Coderblock.ai — the first vibe coding platform where a team of AI employees builds your full-stack app inside a dedicated 3D office. Entrepreneur between San Francisco and Sicily.",
    ogImage: 'https://danilocosta.com/images/danilo-costa.jpg',
    canonicalUrl: 'https://danilocosta.com/',
  })
  usePrerenderReady()

  useEffect(() => {
    const sameAs = Object.values(creator.socials)
      .map(value => typeof value === 'string' ? value : (value as { url?: string } | null)?.url)
      .filter((value): value is string => {
        if (typeof value !== 'string' || !value.trim()) return false
        try { return ['https:', 'http:'].includes(new URL(value).protocol) } catch { return false }
      })
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Person',
          '@id': 'https://danilocosta.com/#person',
          name: 'Danilo Costa',
          url: 'https://danilocosta.com/',
          image: 'https://danilocosta.com/images/danilo-costa.jpg',
          jobTitle: 'CEO & Founder',
          sameAs: [...new Set(sameAs)],
          worksFor: { '@id': 'https://coderblock.ai/#organization' },
          knowsAbout: ['Artificial Intelligence', 'Software development', 'Vibe coding'],
        },
        {
          '@type': 'Organization',
          '@id': 'https://coderblock.ai/#organization',
          name: 'Coderblock.ai',
          url: 'https://coderblock.ai',
          founder: { '@id': 'https://danilocosta.com/#person' },
        },
      ],
    })
    document.head.appendChild(script)
    return () => script.remove()
  }, [])

  return (
    <div className="founder-page bg-background text-foreground antialiased">
      <FounderHero />
      <PlatformCards />
      <CreatorFeeds />
      <FounderThoughts />
      <PlatformSection />
      <FounderBio />
      <FounderJourney />
      <FounderRecognition />
      <MeetingSection />
    </div>
  )
}
